import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/getting-started/introduction.md?raw';

const GettingStartedIntroduction: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GettingStartedIntroduction;
